import { PageHeader as AntdPageHeader } from 'antd';
import { PageHeaderProps as AntdPageHeaderProps } from 'antd/lib/page-header';

export type PageHeaderProps = AntdPageHeaderProps;

export const PageHeader = AntdPageHeader;
export default PageHeader;
